<template>
  <v-flex>
    <v-form id="cashier-login" @submit.prevent="login()">
      <transition name="fade-in-down" appear appear-active-class="animated fadeInDown">
        <v-flex xs12 sm6 d-flex id="outlet-container">
          <v-autocomplete
            :items="outletsList"
            v-model="theOutlet"
            :label="$t('Select Outlet...')"
            name="outlet"
            background-color="rgba(255,255,255,0.85)"
            prepend-inner-icon="store"
            solo
            :menu-props="{ transition: 'slide-y-transition' }"
            :loading="outletsList.length === 0 ? 'warning' : false"
          />
          <!-- <v-combobox
            :items="outletsList"
            v-model="theOutlet"
            :label="$t('Select Outlet...')"
            name="outlet"
            background-color="rgba(255,255,255,0.85)"
            prepend-inner-icon="store"
            solo
            :menu-props="{ transition: 'slide-y-transition' }"
            :loading="outletsList.length === 0 ? 'warning' : false"
          />-->
        </v-flex>
      </transition>
      <transition name="fade-in-down" v-if="isOutletSelected" appear appear-active-class="animated fadeInUp">
        <v-flex xs12 sm6 d-flex id="dd-container">
          <v-autocomplete
            v-model="cashierForm.fullname"
            :items="cashiersList"
            :label="$t('Select User...')"
            name="fullname"
            prepend-inner-icon="person"
            :loading="cashiersListLoading ? 'warning' : false"
            :disabled="cashiersList.length === 0"
            background-color="rgba(255,255,255,0.85)"
            solo
            autofocus
            v-validate="'required'"
            data-vv-as="user name"
            :menu-props="{ transition: 'slide-y-transition' }"
          />
          <!-- <v-combobox
            v-model="cashierForm.fullname"
            :items="cashiersList"
            :label="$t('Select User...')"
            name="fullname"
            prepend-inner-icon="person"
            :loading="cashiersListLoading ? 'warning' : false"
            :disabled="cashiersList.length === 0"
            background-color="rgba(255,255,255,0.85)"
            solo
            autofocus
            v-validate="'required'"
            data-vv-as="user name"
            :menu-props="{ transition: 'slide-y-transition' }"
          />-->
        </v-flex>
      </transition>

      <transition name="fade-in-down" v-if="isOutletSelected" appear appear-active-class="animated fadeInUp">
        <v-flex xs12 sm6 d-flex id="pin-code-container">
          <v-text-field
            slot="activator"
            v-model="cashierForm.pinCode"
            :label="$t('Enter PIN / Password')"
            name="pin"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
            @click:append="showPassword = !showPassword"
            background-color="rgba(255,255,255,0.85)"
            :disabled="cashiersList.length === 0"
            v-validate="'required|min:4'"
            data-vv-delay="1000"
            solo
            prepend-inner-icon="fiber_pin"
            :hint="$t('Directly type into the text field if the password containts non-numerical characters')"
            persistent-hint
            autocomplete="off"
          />
        </v-flex>
      </transition>

      <!-- numpad markup -->
      <transition name="fade-in-up" v-if="isOutletSelected" appear appear-active-class="animated fadeInUp">
        <v-flex id="numpad-row-1">
          <v-btn
            class="key-btn"
            fab
            :medium="!(screenHeight > 768)"
            :large="!!(screenHeight > 768)"
            @click="updatePinCode(1)"
            >1</v-btn
          >
          <v-btn
            class="key-btn"
            fab
            :medium="!(screenHeight > 768)"
            :large="!!(screenHeight > 768)"
            @click="updatePinCode(2)"
            >2</v-btn
          >
          <v-btn
            class="key-btn"
            fab
            :medium="!(screenHeight > 768)"
            :large="!!(screenHeight > 768)"
            @click="updatePinCode(3)"
            >3</v-btn
          >
        </v-flex>
      </transition>
      <transition name="fade-in-up" v-if="isOutletSelected" appear appear-active-class="animated fadeInUp">
        <v-flex id="numpad-row-2">
          <v-btn
            class="key-btn"
            fab
            :medium="!(screenHeight > 768)"
            :large="!!(screenHeight > 768)"
            @click="updatePinCode(4)"
            >4</v-btn
          >
          <v-btn
            class="key-btn"
            fab
            :medium="!(screenHeight > 768)"
            :large="!!(screenHeight > 768)"
            @click="updatePinCode(5)"
            >5</v-btn
          >
          <v-btn
            class="key-btn"
            fab
            :medium="!(screenHeight > 768)"
            :large="!!(screenHeight > 768)"
            @click="updatePinCode(6)"
            >6</v-btn
          >
        </v-flex>
      </transition>
      <transition name="fade-in-up" v-if="isOutletSelected" appear appear-active-class="animated fadeInUp">
        <v-flex id="numpad-row-3">
          <v-btn
            class="key-btn"
            fab
            :medium="!(screenHeight > 768)"
            :large="!!(screenHeight > 768)"
            @click="updatePinCode(7)"
            >7</v-btn
          >
          <v-btn
            class="key-btn"
            fab
            :medium="!(screenHeight > 768)"
            :large="!!(screenHeight > 768)"
            @click="updatePinCode(8)"
            >8</v-btn
          >
          <v-btn
            class="key-btn"
            fab
            :medium="!(screenHeight > 768)"
            :large="!!(screenHeight > 768)"
            @click="updatePinCode(9)"
            >9</v-btn
          >
        </v-flex>
      </transition>
      <transition name="fade-in-up" v-if="isOutletSelected" appear appear-active-class="animated fadeInUp">
        <v-flex id="numpad-row-4">
          <v-tooltip top>
            <v-btn
              class="key-btn clear-btn"
              fab
              icon
              slot="activator"
              :medium="!(screenHeight > 768)"
              :large="!!(screenHeight > 768)"
              @click="clearPinCode()"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{ $t('numpad-reset') }}</span>
          </v-tooltip>
          <v-btn
            class="key-btn"
            fab
            :medium="!(screenHeight > 768)"
            :large="!!(screenHeight > 768)"
            @click="updatePinCode(0)"
            >0</v-btn
          >
          <v-tooltip top>
            <v-btn
              class="key-btn submit-btn"
              fab
              icon
              slot="activator"
              :medium="!(screenHeight > 768)"
              :large="!!(screenHeight > 768)"
              type="submit"
            >
              <v-icon :style="$vuetify.rtl ? 'margin-right:10px;' : ''">{{
                $vuetify.rtl ? 'fa-chevron-left' : 'fa-chevron-right'
              }}</v-icon>
            </v-btn>
            <span>{{ $t('Login') }}</span>
          </v-tooltip>
        </v-flex>
      </transition>
      <!-- / numpad -->
    </v-form>
  </v-flex>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'adminLogin',

  data: () => ({
    screenHeight: 0,
    loading: true,
    isOutletSelected: false,
    theOutlet: '',
    showPassword: false,
    cashiersListLoading: false,
    cashierForm: {
      fullname: '',
      pinCode: ''
    },
    snackbar: false,
    color: ''
  }),

  mounted() {
    this.getScreenResolution()
    this.setOutletsList()
  },

  computed: {
    ...mapGetters({
      outletsList: 'outlets/getFullOutletsList',
      cashiersList: 'auth/loginCashiersList'
    })
  },

  watch: {
    theOutlet: {
      immediate: false,
      handler() {
        this.outletSelected()
      }
    },

    cashiersList: {
      immediate: false,
      handler() {
        if (this.cashiersList.length === 0) {
          this.$validator.errors.add({
            field: 'fullname',
            msg: this.$t('No cashiers found for this outlet')
          })
        }
      }
    }
  },

  methods: {
    ...mapActions({
      processLogin: 'auth/processLogin',
      setLoginCashiersList: 'auth/setLoginCashiersList',
      setAuthToken: 'auth/setAuthToken',
      setOutletsList: 'outlets/setFullOutletsList'
    }),

    getScreenResolution() {
      // Here we need the screen height to adjust the size of the numpad buttons for smaller screens
      this.screenHeight = window.screen.height
    },

    outletSelected() {
      if (!this.theOutlet) {
        return false
      }
      let outletId = this.theOutlet

      // if outlet has been selected already but then it was updated then we update the cashiers list
      if (this.isOutletSelected && typeof outletId === 'number') {
        this.fetchCashiersList(outletId)
      } else {
        // else enable user and pin/password fields if the outlet was selected and make the hint text more visible
        this.isOutletSelected = true
        this.fetchCashiersList(outletId)
      }
      // Since initially the hint message is not in the page, because we're using v-if, switching its color
      // immediately after selectign the outlet will be too fast and will cause setting css for a non-existing
      // element, this why we needed setTimeout to put the execution in the eventloop instead of immediately
      setTimeout(() => {
        document.querySelector('#pin-code-container .v-messages').classList.add('theme--dark')
      }, 0)
    },

    changePasswordHintColor() {
      // Update the hint text to make it more readable, this might be converted into a global function
      let vMessage = document.querySelector('.v-messages__message')
      vMessage.style.color = 'rgba(255,255,255, 0.4)'
      vMessage.style.fontWeight = '300'
      vMessage.style.fontSize = '13px'
    },

    fetchCashiersList(id) {
      this.cashiersListLoading = true
      // The reason we need to pause the vee-validator here is for the case when an outlet was select first,
      // then a cashier name was selected by accidenet or by mistake, then the user realize it wasn't his/her outlet,
      // now they'll select the correct outlet so we need to nullify the old-selected value of the cashier name,
      // BUT HERE the vee-validator will show an error since cashier name was selected then erased, SO..
      // to fix this issue we need to pause the validator, make cashier name null then turn the validator on
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.reset()
        this.$validator.errors.clear()
        this.cashierForm.fullname = null
        this.setLoginCashiersList(id).then(() => {
          this.cashiersListLoading = false
          this.$validator.resume()
        })
      })
    },

    updatePinCode(n) {
      this.cashierForm.pinCode += n
    },

    clearPinCode() {
      this.cashierForm.pinCode = ''
    },

    login() {
      let theEmail = ''
      let thePassword = ''

      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            theEmail = this.cashierForm.fullname
            thePassword = this.cashierForm.pinCode

            this.$auth
              .login({
                data: { email: theEmail, password: thePassword },
                // body: { email: theEmail, password: thePassword },
                rememberMe: false,
                fetchUser: true,
                redirect: '/'
              })
              .then(response => {
                this.setAuthToken(response.data.access_token)
                // console.log(response.data.access_token)
              })
          }
        })
        .catch(error => {
          console.error('Password Error:', error)
        })
    }
  }
}
</script>

<style scoped>
#outlet-container,
#dd-container,
#pin-code-container,
#email-container,
#password-container {
  width: 300px !important;
  margin-left: auto;
  margin-right: auto;
  animation-delay: 0.2s;
}
#dd-container {
  animation-delay: 0;
}
#outlet-container {
  /* margin-top:150px; */
  transition: all 0.9s;
  animation-delay: 0.6s;
}
.password-visibility {
  position: absolute;
  left: 10px;
  z-index: 10;
}
#numpad-row-1,
#numpad-row-2,
#numpad-row-3,
#numpad-row-4 {
  animation-delay: 0.3s;
}
#numpad-row-2 {
  animation-delay: 0.4s;
}
#numpad-row-3 {
  animation-delay: 0.5s;
}
#numpad-row-4 {
  animation-delay: 0.6s;
}
.key-btn,
.clear-btn,
.submit-btn {
  background-color: rgba(0, 0, 0, 0.5) !important;
  font-size: 28px;
  color: white;
  border: 2px solid white;
  border-radius: 50%;
  margin: 10px 20px;
}
.key-btn:disabled {
  opacity: 0.3;
}
.clear-btn,
.submit-btn {
  background-color: rgba(150, 0, 0, 0.6) !important;
}
.submit-btn {
  background-color: rgba(0, 150, 0, 0.6) !important;
}
.submit-btn .v-icon {
  transform: translateX(2px);
}

@media screen and (max-height: 760px) {
  #form-container {
    margin-bottom: 150px;
  }
}
</style>
